<template>
  <div class="portfolioWrap">
    <modals-container/>
    <div class="portfolioInnerWrap">
      <h1 class="title">PORTFOLIO</h1>
      <category-list/>
      <portfolio-item-list/>

    </div>
  </div>

</template>

<script>
    import CategoryList from "./Portfolio/CategoryList";
    import PortfolioItemList from "./Portfolio/PortfolioItemList";

    export default {
        name: "Portfolio",
        components : {
          PortfolioItemList,
          CategoryList,
        },
        created () {
          //console.log('PORTFOLIO CREATED!!');
        },

    }
</script>

<style scoped lang="scss">
  @import "@/styles/Portfolio.scss";
</style>



// WEBPACK FOOTER //
// src/components/menu/Portfolio.vue